<template>
  <div class="selection-header">
    <div class="step step-5">
      <div class="container-x">
        <div class="row">
          <div class="menu" @click="openMenu = !openMenu" :class="{'active': openMenu}">
            <div class="menu-wrapper">
              <span class="bar"></span>
              <span class="bar"></span>
              <span class="bar"></span>
              <span>{{ $t('header.menu') }}</span>
            </div>

            <!-- the menu to open -->
            <div class="mobile-menu">
              <a href="https://www.hydrauliek24.nl/">{{ $t('header.back') }}</a>
              <router-link :to="{ name: 'powerpack-motor-configurator' }" tag="button">{{ $t('header.powerpack') }}</router-link>
              <router-link :to="{ name: 'cilinder-configurator' }" tag="button">{{ $t('header.cylinder') }}</router-link>
              <router-link :to="{ name: 'slang-configurator' }" tag="button">{{ $t('header.hose') }}</router-link>
              <router-link :to="{ name: 'motor-configurator' }" tag="button">{{ $t('header.motor') }}</router-link>
              <hr class="d-block d-md-none">
            </div>
          </div>

          <div class="logo col">
            <a href="/">
              <img class="img-fluid" src="../assets/Logo-header.svg">
            </a>
          </div>
          <div class="col block-container desktop-menu">
            <div class="block">
              <router-link :to="{ name: 'powerpack-motor-configurator' }" tag="span">{{ $t('header.powerpack') }}</router-link>
            </div>
            <div class="block">
              <router-link :to="{ name: 'cilinder-configurator' }" tag="span">{{ $t('header.cylinder') }}</router-link>
            </div>
            <div class="block">
              <router-link :to="{ name: 'slang-configurator' }" tag="span">{{ $t('header.hose') }}</router-link>
            </div>
            <div class="block">
              <router-link :to="{ name: 'motor-configurator' }" tag="span">{{ $t('header.motor') }}</router-link>
            </div>
            <a class="link-back ml-auto mr-3" href="https://www.hydrauliek24.nl/">{{ $t('header.back') }}</a>
          </div>
          <div class="d-flex align-items-center ml-auto ml-lg-0">
            <div ref="cart-trigger" class="cart-button" @click="openCartDropdown">
              <img src="../assets/cart-icon.svg" alt="">
              <img src="../assets/Arrow.svg" alt="">
            </div>
          </div>

          <transition name="fade" mode="out-in">
            <div ref="cart-dropdown"
                 class="cart-dropdown"
                 v-if="isCartOpen"
                 :class="{'active': isCartOpen}">
              <order-cart></order-cart>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import Order from "./step2/order/Order";
import OrderCart from "./step2/order/OrderCart";
import addToCartMixin from "@/mixins/addToCartMixin";

export default {
  name: 'selectionHeader',

  data() {
    return {
      openMenu: false,
    }
  },

  components: {
    Order,
    OrderCart
  },

  computed: {
    ...mapGetters({
      hasMotorOption: 'preference/hasMotorOption',
      isCartOpen: 'cart/isCartOpen',
    }),

    checkSelection() {
      return this.$store.state.preference.selectedMotor && this.hasMotorOption;
    },
  },

  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
    },
    logout() {
      this.$store.dispatch('auth/logout')
    },
    openCartDropdown() {
      if (!this.isCartOpen) {
        this.$store.commit('cart/setCartState', true);
        this.$nextTick(() => {
          window.addEventListener("click", this.closeClickHandler);
        });
      } else {
        this.closeCartDropdown();
      }
    },
    closeClickHandler(e) {
      if (this.$refs['cart-dropdown'] !== undefined && this.$refs['cart-trigger'] !== undefined) {
        const clickedWithin = this.$refs['cart-dropdown'].contains(e.target);
        const clickedOnTrigger = this.$refs['cart-trigger'].contains(e.target);

        if (!clickedWithin && !clickedOnTrigger) {
          this.closeCartDropdown();
        }
      }
    },
    closeCartDropdown() {
      this.$store.commit('cart/setCartState', false);
      window.removeEventListener("click", this.closeClickHandler);
    }
  }
}
</script>

<style scoped lang="scss">

.link-back {
  color: darken(#3db0c7, 10%);
  padding: 5px;
  transition: all ease 0.3s;
  text-decoration: none;
  display: inline-block;
  background-color: lighten(#3db0c7, 25%);
  border-radius: 5px;
  font-weight: 700;
  font-size: 12px;

  &:hover {
    background-color: darken(#3db0c7, 20%);
    color: white;
  }
}

.selection-header {
  position: fixed;
  box-shadow: 0 1px 22px rgba(200, 200, 200, 100%);
  background-color: white;
  top: 0;
  width: 100%;
  height: 80px;
  padding: 0;
  z-index: 99;
  border-bottom: 2px solid rgba(61, 176, 199, 0.2);

  .step {
    padding: 0;
    margin: 0 auto;
    font-family: neue-haas-grotesk-display, sans-serif;
    height: 100%;
  }

  .logo {
    display: flex;
    height: 80px;
    align-items: center;
    margin: auto 0;
    max-width: 160px;
    padding-right: 0;

    @media only screen and (max-width: 576px) {
      margin: 0 auto;
      padding: 0;
      width: 100%;
    }

    @media only screen and (max-width: 768px) {
      margin: 0 auto;
      width: 100%;
    }

    img {
      max-width: 146px;
      max-height: 36px;
    }
  }

  .block-container {
    padding: 0;
    margin-left: 40px;

    .block {
      height: 100%;
      display: flex;
      max-width: 85px;
      margin-right: 50px;
      justify-content: left;
      align-items: center;
      font-size: 18px;
      font-weight: 100;

      span.router-link-active {
        color: #3DB0C7;

        &:after {
          content: '';
          position: relative;
          bottom: 0;
          left: 0;
          right: 0;
          top: 28.5px;
          display: block;
          border-bottom: 2px solid #3DB0C7;
        }
      }

      span {
        cursor: pointer;
        user-select: none;
        font-size: 12px;
        font-weight: 700;
        font-family: neue-haas-grotesk-display, sans-serif;

        &:hover {
          color: darken(#3DB0C7, 20%);
        }
      }
    }
  }

  .auth {
    margin-right: 10px;
    height: 100%;
    width: 120px;
    justify-content: space-around;
    display: flex;
    align-items: center;
    font-size: 12px;

    a {
      color: #3DB0C7;
      transition: all ease 0.3s;

      &:hover {
        text-decoration: none;
        color: darken(#3DB0C7, 20%);
      }
    }

    button {
      transition: all ease 0.3s;
      background-color: #3DB0C7;
      color: white;
      border: none;
      padding: 5px 10px;

      &:hover {
        text-decoration: none;
        background-color: darken(#3DB0C7, 20%);
      }
    }
  }

  .cart-button {
    border: 2px solid #71BC2D;
    transition: all ease 0.3s;
    width: 75px;
    border-radius: 25px;
    height: 40px;
    margin: auto 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;

    &.active {
      .cart-dropdown {
      }
    }

    img {
      transition: all ease 0.3s;
      max-width: 18px;
      max-height: 18px;
    }

    &:hover {
      img {
        transform: scale(1.2);
      }
    }
  }
}

/////// Mobile ///////
.desktop-menu {
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 991px) {
  .desktop-menu {
    display: none;
  }
}


.menu {
  display: none;

  &.active {
    .mobile-menu {
      transition: all ease 0.5s;
      transform-origin: left;
      transform: translate(0);
      z-index: 1000;
      padding: 0 25px;
    }
  }

  @media only screen and (max-width: 991px) {
    height: 80px;
    display: flex;
    flex-direction: column;
    padding: 0 26px;
  }

  @media only screen and (max-width: 991px) {
    padding: 0 20px;
  }

  .menu-wrapper {
    margin: auto 0;
    padding: 15px 10px;
    text-transform: uppercase;
    font-size: 11px;
    font-family: neue-haas-grotesk-display, sans-serif;

    .bar {
      display: block;
      height: 4px;
      width: 100%;
      background-color: #3DB0C7;
      margin-bottom: 5px;

      + .bar {
        margin-bottom: 5px;
      }

      + .bar + .bar {
        margin-bottom: 5px;
      }
    }
  }
}

.mobile-menu {
  list-style: none;
  padding: 0;
  position: absolute;
  top: 80px;
  height: 100vh;
  max-width: 80vw;
  width: 400px;
  right: 0;
  left: 0;
  transform: translate(-105%);
  z-index: -1;
  background-color: white;
  //border-radius: 5px 5px 5px 5px;
  //border: 1px solid #EBEBEB;
  box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.1);
  transition: all ease 0.5s;

  a {
    display: inline-block;
    text-decoration: underline;
    color: #3C3C3B;
    font-family: neue-haas-grotesk-text, sans-serif;
    opacity: 0.5;
    font-size: 12px;
    padding: 13px 0 9px 0;
    margin-bottom: 10px;
  }

  button {
    display: block;
    width: 100%;
    text-align: left;
    border: 0;
    background: transparent;
    padding-top: 7px;
    padding-bottom: 7px;
    margin-bottom: 7px;
    font-weight: 600;
    font-size: 14px;
    font-family: neue-haas-grotesk-text, sans-serif;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}


.shake img {
  animation: shake 0.5s ease;
  animation-delay: 0.3s;
  animation-duration: 0.5s;
  animation-iteration-count: 1;
}

@keyframes shake {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }

}

</style>
